// extracted by mini-css-extract-plugin
export var lg = "_46-4";
export var md = "_46-3";
export var sm = "_46-2";
export var xs = "_46-1";
export var xxs = "_46-0";